export enum Action {
	NONE = 'Action::NONE',
	INIT = 'Action::INIT',
	SPIN = 'Action::SPIN',
	FREESPIN = 'Action::FREESPIN',
	MIMICFREESPIN = 'Action::MIMICFREESPIN',
	RESPIN = 'Action::RESPIN',
	PICK = 'Action::PICK',
	SKIPPICK = 'Action::SKIPPICK',
	AVALANCHE = 'Action::AVALANCHE',
	SCATTER_AND_AVALANCHE = 'Action::SCATTER_AND_AVALANCHE',
	EXPLOSION = 'Action::EXPLOSION',
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/logic/Action.ts